var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"dropdown-item",attrs:{"type":"button"},on:{"click":_vm.diversityRequest}},[_c('i',{staticClass:"fas fa-users"}),_vm._v(" "+_vm._s(_vm.$t('Request DE&I data'))+"\n  ")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71c2d986","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Job/JobMassiveAction/JobMassiveActionDiversityRequest.vue
// module id = null
// module chunks = 